import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

const NeonButton = ({ 
  children, 
  variant = "primary", 
  size = "default",
  className,
  disabled,
  ...props 
}) => {
  const variants = {
    primary: "bg-gradient-to-r from-violet-600 to-indigo-600 hover:from-violet-500 hover:to-indigo-500 text-white shadow-[0_0_20px_rgba(124,58,237,0.3)]",
    secondary: "border border-white/10 text-white hover:bg-white/5 hover:border-white/20",
    cyan: "bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-400 hover:to-teal-400 text-white shadow-[0_0_20px_rgba(6,182,212,0.3)]",
    ghost: "text-gray-400 hover:text-white hover:bg-white/5",
  };

  const sizes = {
    sm: "px-4 py-2 text-sm",
    default: "px-6 py-3",
    lg: "px-8 py-4 text-lg",
  };

  return (
    <motion.button
      whileHover={{ scale: disabled ? 1 : 1.02 }}
      whileTap={{ scale: disabled ? 1 : 0.98 }}
      disabled={disabled}
      className={cn(
        "rounded-full font-medium tracking-wide transition-colors duration-200",
        variants[variant],
        sizes[size],
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      {...props}
    >
      {children}
    </motion.button>
  );
};

export default NeonButton;
